define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var I18n = require('i18n!nls/main');
    var _ = require("underscore");

    var LoaderTPL = require('text!tmpls/loader-page.tpl').default;
    var PageSave = require('views/save_page');

    var about = require('behaviors/about');
    var popover = require('behaviors/popover');
    var modal = require('behaviors/modal');
    var AppConfig = require('config/application');

    return Marionette.LayoutView.extend({
        className: 'content inner-content hide',
        template: LoaderTPL,
        pageName: 'BasePage',
        dataPage: null,
        object: null,
        scrollTop: null,
        openedPanel: false,
        disabledBtns: false,

        initialize: function () {
            this.disableBodyScroll();
            //app.curPage = this;
            this.on('show', this.afterRender, this);
            this.listenTo(app.regionContent, 'show', this.hidePanelBtns);
        },

        events: function () {
            return _.extend({}, this.parentEvents, this.newEvents);
        },

        newEvents: {},

        parentEvents: {
            'click .js-back': 'HistoryBack'
        },

        behaviors: function () {
            return _.extend({}, this.parentBehaviors, this.newBehaviors);
        },

        newBehaviors: {},

        parentBehaviors: {
            'popover': {behaviorClass: popover},
            'modal': {behaviorClass: modal},
            'about': {behaviorClass: about}
        },

        onRender: function () {
            this.binding = app.Rivets.bind(this.el, {model: this.model});
            $('body').css('overflow-y', 'auto');
        },

        afterRender: function () {
            if (app.loaded) {
                this.$el.addClass('animated fadeIn').removeClass('hide');
            }
            // this.$el.lptSetter();
        },

        HistoryBack: function () {
            window.history.back();
        },

        setState: function (obj, key, hash) {
            key = key || false;
            hash = hash || false;

            if (!key) {
                if (obj instanceof Backbone.Collection) {
                    this.dataType = 'collection';
                    this.dataPage = obj.toJSON();
                    this.object = obj;
                } else if (obj instanceof Backbone.Model) {
                    this.dataType = 'model';
                    this.dataPage = _.clone(obj.toJSON());
                    this.object = obj;
                } else {
                    this.dataType = 'array';

                    if (this.dataPage == null)
                        this.dataPage = this.object = {};

                    if (obj instanceof Backbone.Collection) {
                        this.dataPage[key] = obj.toJSON();
                        this.object[key] = obj;
                    }
                }
            }
        },

        checkState: function (obj) {
            var that = this;

            if (!this.openedPanel) {
                var equal = true;

                // сравниваем текущее сосотояние и первоночальное
                if (obj instanceof Object) {
                    _.each(obj, function (el, i) {
                        equal = equal || _.isEqual(el.toJSON(), that.dataPage[i]);
                    });
                } else {}

                if (obj !== null) {
                    equal = _.isEqual(obj.toJSON(), that.dataPage);
                }

                if (!equal) {
                    app.page_data_change = true;
                    this.showPanelBtns();
                } else {
                    app.page_data_change = false;
                    this.hidePanelBtns();
                }
            }
        },

        Save: function (callback) {
            callback = callback || function () {};
            if (this.object.get('checkValidation') && !this.object.isValid()) {

                app.message.error(this.object.validationError);
                this.hidePanelBtns();
                app.Vents.trigger('app:unBlockUi');
                return;
            }

            var actualObj = this.object.save({
                silent: true,
                success: function (response) {
                    if (response.status == AppConfig.STATUS_OK) {

                    }
                }
            }, undefined, undefined, callback);

            if (this.dataType == 'model') {
                if (actualObj.readyState == 1) {
                    actualObj = this.object;
                }
            }

            this.setState(actualObj);
            this.hidePanelBtns();
            app.Vents.trigger('page:saved', this.object.toJSON());
            app.Vents.trigger('panel_btns:success');
        },

        Cancel: function () {
            switch (this.dataType) {
                case 'collection':
                    this.object.set(this.dataPage);
                    this.object.sort();
                    break;
                case 'model':
                    this.object.set(this.dataPage);
                    break;
            }

            this.object.trigger('PanelCancel');
            this.hidePanelBtns();
            app.Vents.trigger('panel_btns:cancel');
        },

        showPanelBtns: function (animate, showCancel) {
            animate = animate === undefined ? true : animate;
            var pageSave = new PageSave({disabled: this.disabledBtns});
            this.listenTo(pageSave, 'save', this.Save);
            this.listenTo(pageSave, 'cancel', this.Cancel);
            app.regionPageSave.show(pageSave);
            this.openedPanel = true;
            var hideCancel = !showCancel;

            $('#b-footer-btns').addClass('slideInUp').removeClass('hide slideOutDown');
            if (animate) {
                $('#b-footer-btns').addClass('animated');
            } else {
                $('#b-footer-btns').removeClass('animated');
            }

            if (this.pageName && hideCancel) {
                $('.js-btn-cancel').hide();
            }

            $('body').addClass('save-panel-open');
            app.Vents.trigger('Panel:showed');
        },

        disablePanelBtns: function () {
            this.disabledBtns = true;
            $('.js-btn-cancel').attr('disabled','1');
            $('.js-btn-save').attr('disabled','1');
        },

        enablePanelBtns: function () {
            this.disabledBtns = false;
            $('.js-btn-cancel').removeAttr('disabled');
            $('.js-btn-save').removeAttr('disabled');
        },

        hidePanelBtns: function (animate) {
            animate = animate === undefined ? true : animate;
            app.regionPageSave.empty();
            this.openedPanel = false;

            if (animate) {
                $('#b-footer-btns').addClass('slideOutDown').removeClass('slideInUp');
            }

            $('body').removeClass('save-panel-open');
            app.Vents.trigger('Panel:hided');
        },

        Change: function () {
            this.checkState(this.object);
        },

        disableBodyScroll: function () {
            $('body').css('overflow-y', 'hidden').scrollTop(0);
        },

        onDestroy: function () {
            var that = this;
            that.off('show', that.afterRender);
        }
    });
});
